"use strict";

exports.__esModule = true;

var ASTNode =
/** @class */
function () {
  function ASTNode(tokenizer) {
    this.tokenizer = tokenizer;
  }

  return ASTNode;
}();

exports["default"] = ASTNode;